export default __webpack_public_path__ + "static/media/APP-322-216.b4383b29.png";